@if (referral(); as referral) {
  <div class="flex items-center justify-between">
    <div class="flex items-center gap-4">
      <ng-content select="referral-dashboard" />
      <ng-content select="referral-status" />
      <ng-content select="referral-urgency" />
      <p class="!m-0">ID: {{ referral.uid }}</p>
    </div>

    <div>
      <ng-content select="uploading-content" />
    </div>

    <div class="flex gap-4">
      @if (isSaving()) {
        <div class="mx-2 flex items-center justify-center gap-2 text-gray-400">
          <mat-icon>save</mat-icon>
          <span>saving...</span>
        </div>
      }

      <ng-content />
    </div>
  </div>
}
